import { configureStore } from '@reduxjs/toolkit';
import rootReducer from '../reducers/rootReducer';
import { tasksApi } from '../services/tasksApi';
import fcmMiddleware from '../redux/middleware/fcmMiddleware';
import navigationMiddleware from '../redux/middleware/navigationMiddleware';
import socketMiddleware from '../redux/middleware/socketMiddleware';
import { formsApi } from '../services/formsApi';
import { projectsApi } from '../services/projectsApi';
import { customFieldsApi } from '../services/customFieldsApi';
import { workspacesApi } from '../services/workspacesApi';
import { workspacePaymentApi } from '../services/workspacePaymentApi';
import { productsPaymentApi } from '../services/productsPaymentApi';
import { remindersApi } from '../services/remindersApi';
import { personalAccessTokensApi } from '../services/personalAccessTokensApi';

export default function initStore(initialState = {}) {
  return configureStore({
    reducer: rootReducer,
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
        immutableCheck: false,
      }).concat(
        tasksApi.middleware,
        formsApi.middleware,
        projectsApi.middleware,
        customFieldsApi.middleware,
        workspacesApi.middleware,
        workspacePaymentApi.middleware,
        productsPaymentApi.middleware,
        remindersApi.middleware,
        personalAccessTokensApi.middleware,
        fcmMiddleware,
        navigationMiddleware,
        socketMiddleware,
      ),
    devTools: process.env.NODE_ENV !== 'production',
  });
}
